import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  vertical-align: middle;
  border-left-width: 0px;
  border-left-color: var(--background-background-disabled);
  border-bottom-width: 1px;
  border-bottom-color: var(--background-background-disabled);
  display: flex;
  position: relative;
  margin-top: 0px;
  z-index: 9;
  width: 100%;
  &:before {
    content: '';
    width: 0px;
    height: 54px;
    height: auto;
    display: inline;
    background: var(--background-background-disabled);
    top: 0px;
    left: 0px;
  }
  .buttonchevron1 {
    outline: 0;
    border-radius: 4px;
    padding: 7px;
    margin-left: 8px;
  }
  .buttonchevron1:focus {
    border-radius: 4px;
    background-color: var(--decorative-decorative08);
  }
  .openVirtual {
    display: block;
  }
  .open {
    box-shadow: 0 4px 16px -8px var(--text-text01);
  }

  .shadow {
    box-shadow: 0 15px 16px 0px var(--text-text01);
  }

  .buttonChevron {
  }

  .WrapCourseDetailOneCourse {
    display: flex;
    position: inherit;
    width: 160px;
    top: 0px;
    float: left;
  }
  .WrapCourseDetailOneCourse > div > div {
    min-width: 160px;
  }
  .WrapCourseDetailOneCourse label {
    max-width: 160px;
  }
  .WrapCourseDetailOneCourse .title label {
    max-width: 100%;
  }

  .RightPanelOneCourse {
    float: right;
    box-shadow: none;
    padding-right: 8px;
    justify-content: flex-end;
  }
  // @media (min-width: 992px) {
  //   z-index: 99;
  // }
  @media (min-width: 768px) {
    margin-left: 50px;
    border-bottom-color: var(--interaction-primary);
    position: relative;
    margin-top: 0px;
    width: calc(100% - 50px);
    z-index: 9;
    &&::before {
      width: 34px;
      background-color: #fbfdff;
      border-right-width: 1px;
      border-color: var(--background-background-disabled);
    }
    .buttonChevron {
      display: none;
      cursor: pointer;
    }
    .RightPanelOneCourse {
      float: left;
      justify-content: flex-start;
    }
    .WrapCourseDetailOneCourse {
      display: flex;
      position: inherit;
      margin-left: 8px;
      width: auto;
      top: 0px;
      float: left;
    }
    .WrapCourseDetailOneCourse > div > div {
      min-width: 1px;
      display: flex;
    }
    .WrapCourseDetailOneCourse label {
      max-width: 100%;
      /* -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box; */
    }
  }
`;

export const Bar = styled.div`
  background-color: var(--decorative-decorative10);
  align-items: center;
  border-radius: 4px;
  margin: 5px 5px 5px 5px;
  width: calc(100% - 10px);
  > div {
  }

  @media (min-width: 768px) {
    float: left;
    width: calc(100% - 10px);
    justify-content: flex-start;
    > div {
      width: auto;
      display: flex;
      float: left;
    }
  }
`;

export const BarWrap = styled.div.attrs((props: any) => ({
  shadow: props.shadow
}))`
  background-color: #fff;
  width: 100%;
  box-shadow: ${(props) =>
    props.shadow ? '0 4px 11px -8px var(--text-text01)' : 'none'};

  @media (min-width: 768px) {
    margin-left: 0px;
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  margin-right: 19px;
  height: auto;
  position: relative;
  border-radius: 4px;
  outline: 0;
  width: 100%;
  .buttonInteraction {
    display: flex;
    border-radius: 4px;
    width: 100%;
  }
  .buttonInteraction:hover {
    background-color: var(--decorative-decorative13);
    outline: 0;
  }
  .buttonInteraction:focus {
    background-color: var(--decorative-decorative12);
    outline: 0;
  }
  label.clickable {
    cursor: pointer;
    text-align: start;
  }
  label.active {
    color: #ffffff;
  }
  > div {
  }
  @media (min-width: 768px) {
    margin-right: 0px;
    display: flex;
    width: auto;
    .buttonInteraction {
      width: auto;
    }
  }
`;

export const RightPanelContent = styled.div`
  align-items: center;
  display: flex;
  height: 40px;
  padding-left: 0px;
  justify-content: space-between;
  width: 100%;
  .countCourses {
    display: block;
  }

  @media (min-width: 768px) {
    float: left;
    box-shadow: none;
    padding-right: 8px;
    justify-content: flex-start;
    .countCourses {
      display: none;
    }
  }
`;

export const WrapCourseDetail = styled.div`
  display: none;
  position: absolute;
  z-index: 4;
  margin: 0 auto;
  background-color: var(--decorative-decorative10);
  width: calc(100% - 9px);
  left: 4px;
  border-radius: 4px;
  padding-top: 0px;
  padding-bottom: 0px;
  top: 112px;
  .left {
    left: 0;
  }

  .right {
    right: 0;
    >div: last-child {
      padding-bottom: 50px !important;
      padding-top: 20px !important;
    }
  }

  .top {
    top: 0px;
  }
  .default.top {
    position: fixed;
    z-index: 9;
    top: 0px;
    right: 0px;
    bottom: 0px;
    height: 100%;
  }

  @media (min-width: 768px) {
    display: flex;
    position: inherit;
    margin-left: 8px;
    width: calc(100% - 150px);
    top: 0px;
    float: left;
    height: 40px;
    .top {
      top: 50px;
    }
  }

  @media (min-width: 768px) {
    width: auto;
    float: left;
    p.top {
      top: 35px;
    }
  }
`;
